<template>
  <div style="padding: 0 10px">
    <Form layout="code" @search="search"></Form>
    <WmsTable
      :columns="columns"
      :dataSource="dataSource"
      :isPagination="false"
      :hasHeader="false"
      isExpanded
      :keepExpended="true"
    >
      <div slot="image" slot-scope="{text, record, index }">
        <ImgPreviews :images="[record.productImg]"></ImgPreviews>
      </div>
      <div slot="expandedRender" slot-scope="{ record }">
        <el-collapse accordion v-model="collapseKey">
          <el-collapse-item name="abnormal">
            <template slot="title">
              <strong> 异常处理 </strong>
            </template>
            <AbnormalSubmit :record="record" @DoStockIn='DoStockIn' :disabledChoose="true"/>
            <DefectiveSubmit :record="record" @DoStockIn='DoStockIn' @toClient="toClient"/>
          </el-collapse-item>
        </el-collapse>
      </div>
    </WmsTable>
  </div>
</template>

<script>
import Form from "@/views/abnormal/components/form";
import WmsTable from "@/components/WmsTable";
import AbnormalSubmit from "@/views/abnormal/unpacking/components/Abnormal/AbnormalSubmit";
import DefectiveSubmit from "@/views/abnormal/unpacking/components/Abnormal/DefectiveSubmit";
import { columns } from "@/views/abnormal/unpacking/columns";
import { pkgDetail } from "@/apis/abnormal";
import ImgPreviews from "@/components/ImgPreviews";
export default {
  name:"abnormal_unpacking",
  components: { Form, WmsTable, AbnormalSubmit, DefectiveSubmit,ImgPreviews },
  props: {},
  data() {
    return {
      columns,
      dataSource:[],
      formInline: {},
      query: {
        current: 1,
        pageSize: 20,
      },
      collapseKey: 'abnormal'
    };
  },

  created() {},

  methods: {
    search(formInline) {
      this.formInline = formInline;
      let hasThisPkg;
      if (formInline.pkgCode) {
        // this.dataSource.map(item =>{
        //   if(item.pkgCode == formInline.pkgCode){
        //   this.$message.error("已存在该批次包");
        //   hasThisPkg = true
        //   }
        // })
        // if(hasThisPkg){
        //   return false
        // }
        this.getdataSource();
      }
    },
    getdataSource() {
      this.dataSource = []
      let params = {
        ...this.formInline,
      };
      pkgDetail(params).then(({ code, data }) => {
        if (code === 0) {
          if(data.status == 4){
            this.$message.warning("成品不可以创建异常")
            return false
          }
          if(data.productType == 3){
            this.$message.warning("组合商品不可拆包")
            return false
          }
          // if(data.status == 3 && data.combinationProductItemFlag){
          //   this.$message.warning("组合子商品移库质检区后,不能新增异常")
          //   return false
          // }
          this.dataSource = [data];
        }
      });
    },
    DoStockIn(){
      this.getdataSource()
    },
    toClient(){
      const doc = document.querySelector('.el-main')
      doc.scrollTo(0,400)
    }
  },
};
</script>

<style scoped lang="less"></style>
